import { render, staticRenderFns } from "./detail_investments.vue?vue&type=template&id=e6b02a16&scoped=true&"
import script from "./detail_investments.vue?vue&type=script&lang=js&"
export * from "./detail_investments.vue?vue&type=script&lang=js&"
import style0 from "./detail_investments.vue?vue&type=style&index=0&id=e6b02a16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b02a16",
  null
  
)

export default component.exports